import { styled, css } from 'styled-components';
export const Group = styled.div `
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
`;
export const Wrapper = styled.div `
  ${({ theme, xs }) => (xs ? theme.typography.textExtraSmall : theme.typography.textMedium)};
  ${({ theme, xs }) => (xs ? theme.typography.weightMedium : theme.typography.weightDefault)};
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  border-radius: 6px;
  gap: 8px;
  padding: ${({ xs }) => (xs ? '2px 6px' : '4px 8px')};
  position: relative;

  background-color: ${({ variantColors }) => variantColors.bg};
  color: ${({ variantColors }) => variantColors.text};

  ${({ interactive, variantColors }) => interactive &&
    css `
      cursor: pointer;
      box-shadow: inset 0 0 0 1px ${variantColors.border};

      &:hover {
        box-shadow: inset 0 0 0 2px ${variantColors.border};
      }
    `}
`;
